module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-title-2-5afe65005b2d8ac19c387121b97ed0b4.png";